import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import HeaderTitle from '../../../components/HeaderTitle'
import { Controller, useForm } from 'react-hook-form'
import BackButton from '../../../components/BackButton'
import axios from 'axios'
import { useSelector } from 'react-redux'
import swal from 'sweetalert'
import { Helmet } from 'react-helmet'
import { useLocation } from 'react-router-dom'
import ControlPage from '../../Auth/ControlPage'
import { hasMuhasebeRole, isAdmin } from '../../../utils/roleUtils'

function UpdateCompanies() {
    const form = useForm()
    const navigate = useNavigate()
    const { companyID } = useParams()
    let { state } = useLocation()

    console.log("state", state)

    const { token, role } = useSelector((state) => state.auth)

    const getCompany = () => {
        axios.get(`${process.env.REACT_APP_SERVICE_URL}/company/${companyID}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .then((response) => {
                //console.log(response.data)
                form.setValue('companyName', response.data.name)
                form.setValue('companyTypeId', response.data.companyTypeId)

            })
            .catch((error) => {
                console.error(error)
                swal('Şirket getirilirken hata oluştu', {
                    icon: 'error'
                })
            })
    }

    const updateCompany = (data) => {
        data.id = companyID
        axios.put(`${process.env.REACT_APP_SERVICE_URL}/company`, {
            name: data.companyName,
            id: data.id,
            companyType: data.companyTypeId
        }, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .then((response) => {
                console.log(response.data)
                swal('Şirket başarıyla güncellendi', {
                    icon: 'success'
                })
                navigate(-1);
            })
            .catch((error) => {
                console.error(error)
                swal('Şirket güncellenirken hata oluştu', {
                    icon: 'error'
                })
            })

    }

    useEffect(() => {
        if (!hasMuhasebeRole(role) || isAdmin(role)) {
            getCompany()
        }
    }, [])

    if (hasMuhasebeRole(role) && !isAdmin(role)) {
        return <ControlPage />
    }

    return (
        <div className='container-fluid'>
            <Helmet>
                <title>Şirket Güncelle</title>
                <meta name='description' content='Şirket Güncelle form' />
                <meta name='viewport' content='width=device-width, initial-scale=1.0' />
            </Helmet>
            <HeaderTitle title='Şirket Güncelle' />

            <div className='row'>
                <div className='col-md-3'>
                    <div className='card'>
                        <div className='card-body'>
                            <BackButton />
                            <form className='mt-3' onSubmit={form.handleSubmit(updateCompany)}>
                                <div className='mb-3'>
                                    <label htmlFor='companyName' className='form-label'>Firma Adı</label>
                                    <Controller name='companyName' control={form.control} render={({ field }) => <input type='text' className='form-control' {...field} value={field.value || ''} />} />
                                </div>

                                <div className='mb-3'>
                                    <button type='submit' className='btn btn-dark btn-app btn-app--lg'>Güncelle</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default UpdateCompanies